module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-form/time-roll-san-form.component.css
// module id = ./src/app/hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-form/time-roll-san-form.component.css
// module chunks = main